import React from "react"
import { Link } from "gatsby"
import { useStaticQuery } from "gatsby"
import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import DorotButton from "./DorotButton"

export default function RecipeCategory() {
  const data = useStaticQuery(graphql`
    query {
      allWpRecipeCategory(sort: { id: ASC }, limit: 6) {
        edges {
          node {
            title
            slug
            featuredImage {
              node {
                gatsbyImage(
                  placeholder: BLURRED
                  # layout: FULL_WIDTH
                  formats: AVIF
                  width: 415
                  height: 415
                )
              }
            }
          }
        }
      }
    }
  `)

  let categories = data.allWpRecipeCategory.edges

  return (
    <section id="recipe-category" className="bg-accent-purple">
      <div className="px-7.5 md:px-12.5 lg:px-16 pt-10 pb-[52px] 1024:text-center md:pb-[54px] 1024:pb-10 limit-1440 lg:py-10">
        <div className="_1024:max-w-2xl max-w-xs_ m-auto space-y-3.5 1024:space-x-2">
          <p className="text-_2432 text-white font-goldplay font-semibold mb-2 lg:mb-4.5">
            Explore our recipes and discover your new favorite dishes & flavor
            combinations!
          </p>
          <h2 className="text-white font-gelica lg:text-_3642 1024:text-_3642 text-_2830  font-bold">
            Find Inspiration <br className="1024:hidden"/> For Your Next <br/> Culinary Masterpiece
          </h2>
        </div>
        <div className="w-fit md:m-auto flex flex-row flex-wrap 1024:pt-10 pt-14 grid lg:gap-y-6 1024:gap-y-4 gap-y-5 lg:gap-x-7 1024:gap-x-5 gap-x-2.5 lg:grid-cols-recipeCategory md:grid-cols-recipeCategory_lg_mobile 1024:grid-cols-recipeCategory_tablet grid-cols-recipeCategory_mobile ">
          {categories.map((category, index) => {
            const categoryImage = getImage(
              category.node.featuredImage.node.gatsbyImage
            )

            return (
              <Link to={"/recipes/" + category.node.slug} key={index}>
                <div className="relative overflow-hidden">
                  {categoryImage && (
                    <GatsbyImage
                      image={categoryImage}
                      alt="Dorot Recipe Category"
                      className="hover:scale-110 transition-transform ease-in-out delay-150 duration-500"
                    />
                  )}
                  <div className="absolute inset-x-0 lg:bottom-20 1024:bottom-14 bottom-5 px-[5px]">
                    <DorotButton
                      text={category.node.title}
                      link={"/recipes/" + category.node.slug}
                      width="lg:w-button_size 1024:w-52 w-full"
                      padding="1024:py-3.5 py-[5px]"
                    />
                  </div>
                </div>
              </Link>
            )
          })}
        </div>
        <div className="w-full mt-12 text-center">
          <DorotButton
            text={"Browse More Recipes"}
            link="/recipes"
            width="w-fit"
            padding="py-3.5 px-12.5"
          />
        </div>
      </div>
    </section>
  )
}
